import { render, staticRenderFns } from "./descEditor.vue?vue&type=template&id=65070452&scoped=true&"
import script from "./descEditor.vue?vue&type=script&lang=js&"
export * from "./descEditor.vue?vue&type=script&lang=js&"
import style0 from "./descEditor.vue?vue&type=style&index=0&id=65070452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65070452",
  null
  
)

export default component.exports